TECL_Validation = {

    // Initialise validation
    Initialise: function() {

        $("body").off(".validation");

        TECL_Validation.NumberValidation();
    },

    // Set up validation for number inputs
    NumberValidation: function() {

        $("body").on("keydown.validation", "input[type='number']", function(e) {

            // Allow: backspace, delete, tab, escape, enter
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode >= 35 && e.keyCode <= 40)) {
                // let it happen, don't do anything
                return;
            }

            // Do not allow "." if an attribute called data-integer set to "true" is present
            if ($(this).attr("data-integer") !== "true" && e.keyCode === 190) {
                return;
            }

            // Only allow numbers
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    }
};